"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _2 = require("../..");

var _mobxReact = require("mobx-react");

var _lodash = _interopRequireDefault(require("lodash"));

var _helpers = require("../../_helpers/helpers");

var _bind = _interopRequireDefault(require("classnames/bind"));

var _fileupload = _interopRequireDefault(require("../fileupload"));

var _useUtils = require("../../_helpers/use-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./SurveyQuestion.css");

var _styles = {
  "title-section": "SurveyQuestion__title-section___2bPTK",
  "question-text": "SurveyQuestion__question-text____P4tC",
  "no-margin": "SurveyQuestion__no-margin___3Ab0-",
  "question-subtitle": "SurveyQuestion__question-subtitle___1xn3e",
  "help-link": "SurveyQuestion__help-link___3E8zq",
  "no-subtitle": "SurveyQuestion__no-subtitle___eX6M3",
  "ai-question-image-invisible": "SurveyQuestion__ai-question-image-invisible___2lQCU",
  "ai-question-image-visible": "SurveyQuestion__ai-question-image-visible___1Oi27",
  "tooltip": "SurveyQuestion__tooltip___20Erh",
  "button-group": "SurveyQuestion__button-group___3wpyR",
  "button": "SurveyQuestion__button___1YNU8",
  "no-min-width": "SurveyQuestion__no-min-width___3w1op",
  "button-group-wrap": "SurveyQuestion__button-group-wrap___33Ed5",
  "helper-text": "SurveyQuestion__helper-text___qi644",
  "error-message": "SurveyQuestion__error-message___3XFLd",
  "error-label": "SurveyQuestion__error-label___1EGUO",
  "no-card": "SurveyQuestion__no-card___pIIGw",
  "file-upload": "SurveyQuestion__file-upload___3GyIC",
  "file-upload-container": "SurveyQuestion__file-upload-container___2AEQy",
  "file-upload-results": "SurveyQuestion__file-upload-results___3wyND",
  "checkbox-dropdown": "SurveyQuestion__checkbox-dropdown___2NrAs",
  "multi-select-field": "SurveyQuestion__multi-select-field___2gqyj",
  "dropdown-select": "SurveyQuestion__dropdown-select___3FrQd",
  "fade_in": "SurveyQuestion__fade_in___VAyFO"
};

const styles = _bind.default.bind(_styles);

const parseNumeric = numeric => {
  return parseFloat(numeric.replace(/[^0-9.]/g, ''));
};

const parseAnswerValue = (answerValue, answerType) => {
  switch (answerType) {
    case 'currency':
      return parseNumeric(answerValue) * 100;

    case 'number':
    case 'percentage':
      return parseNumeric(answerValue);

    case 'year':
      return parseInt(answerValue, 10);

    default:
      return answerValue;
  }
};

const SurveyQuestion = (0, _mobxReact.observer)(({
  className,
  children,
  text,
  subtitle,
  answerType,
  answerValue,
  selectedValues,
  answerOptions,
  placeholder,
  helperText,
  errorText,
  tooltip,
  error,
  maxFileSize,
  acceptedFiletypes,
  onAnswerSelected,
  onBlur,
  onChange,
  onClick,
  onFileAdded,
  onFileCancelled,
  onFileRemoved,
  onFileProgressCompleted,
  withCard = true,
  withCardMargin = true,
  dataTestId,
  questionTextSize = 18,
  questionSubtitleSize = 15,
  helpLinkText,
  onHelpLinkClick,
  label,
  allowButtonDeselect = true,
  buttonGroupNoMinWidth = false,
  buttonGroupWrap = false,
  fileUploadFlexDirection,
  bottomContent,
  disabled,
  chatBotQuestion,
  chatBotPrompt,
  multiSelectDropdown,
  ...props
}) => {
  const [selectedId, setSelectedId] = (0, _react.useState)(Array.isArray(answerValue) ? '' : answerValue || '');
  (0, _react.useEffect)(() => {
    if (answerValue && !Array.isArray(answerValue)) {
      setSelectedId(answerValue);
    }
  }, [answerValue]);
  const [inputValue, setInputValue] = (0, _react.useState)(Array.isArray(answerValue) ? '' : answerValue !== null && answerValue !== void 0 ? answerValue : '');
  const [selectedElems, setSelectedElems] = (0, _react.useState)(Array.isArray(answerValue) ? answerValue : selectedValues || []);
  const [showImage, setShowImage] = (0, _react.useState)(false);
  const [showDropdownMultiSelect, setShowDropdownMultiSelect] = (0, _react.useState)(false);

  const renderButton = answerOption => {
    return _react.default.createElement("div", {
      key: `${answerOption.id}`,
      className: styles('answer-button')
    }, _react.default.createElement(_2.Button, {
      dataTestId: dataTestId && `${dataTestId}-${answerOption.id}`,
      className: styles('button'),
      label: answerOption.text,
      small: true,
      variant: 'outlined-gray',
      surveySelectedVariant: answerType === 'button_multiple_select' ? selectedElems.includes(answerOption.id) : answerOption.id === selectedId,
      selected: answerType === 'button_multiple_select' ? selectedElems.includes(answerOption.id) : answerOption.id === selectedId,
      onClick: () => {
        if (answerType === 'button_multiple_select') {
          const newList = selectedElems.slice(0);
          const existingIndex = newList.indexOf(answerOption.id);

          if (existingIndex > -1) {
            newList.splice(existingIndex, 1);
          } else {
            newList.push(answerOption.id);
          }

          setSelectedElems(newList);

          if (onChange) {
            onChange(newList, newList);
          }

          if (onAnswerSelected) {
            onAnswerSelected(newList);
          }
        } else {
          if (selectedId === answerOption.id && !allowButtonDeselect) {
            return;
          }

          const value = selectedId === answerOption.id ? '' : answerOption.id;
          setSelectedId(value);

          if (onChange) {
            onChange(value, value);
          }

          if (onAnswerSelected) {
            onAnswerSelected(value);
          }
        }
      }
    }));
  };

  const renderChatBotMouseOver = () => {
    return _react.default.createElement("span", {
      onClick: () => {
        chatBotPrompt && chatBotPrompt();
      },
      onMouseOver: () => chatBotQuestion && setShowImage(true)
    }, _react.default.createElement(_2.Image, {
      className: styles(showImage ? 'ai-question-image-visible' : 'ai-question-image-invisible'),
      src: `data:image/svg+xml,%3Csvg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M26.087 21.0689C27.3029 18.9942 28 16.5785 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28C16.9646 28 19.714 27.0785 21.9774 25.5063L27.6967 27.0465L26.087 21.0689Z' fill='%230B654A'/%3E%3Cpath d='M22.034 8.16663V19.8333H20.5895L20.7382 9.60485L20.741 9.57846H20.5653L19.5411 19.8333H18.0993L19.3602 9.6076L19.363 9.57846H19.1873L17.051 19.8333H15.6092L17.9822 9.57846H17.8065L14.2842 19.8333H13.8721L10.3578 9.59688L10.3523 9.57846H10.1741L12.5499 19.8333H11.1078L8.97424 9.59963L8.97149 9.57846H8.79332L10.057 19.8333H8.61516L7.59622 9.60238L7.59347 9.57846H7.41778L7.5668 19.8333H6.125V8.16663H11.0652L13.888 16.4504L13.8932 16.4663H14.263L17.0908 8.16663H22.034Z' fill='white'/%3E%3C/svg%3E%0A`,
      width: 20,
      height: 20
    }));
  };

  const renderToolTip = () => {
    return _react.default.createElement(_2.Tooltip, {
      className: styles('tooltip'),
      text: tooltip ? tooltip : ''
    }, _react.default.createElement(_2.FontAwesome, {
      name: _2.IconEnum.info_circle,
      variant: 'regular',
      size: 20
    }));
  };

  const renderHelp = () => {
    return _react.default.createElement(_react.default.Fragment, null, helpLinkText && onHelpLinkClick && _react.default.createElement(_2.Button, {
      label: _react.default.createElement(_react.default.Fragment, null, helpLinkText, _react.default.createElement(_2.Icon, {
        name: typeof onHelpLinkClick !== 'string' ? _2.IconEnum.question_circle : _2.IconEnum.external_link,
        size: 18,
        color: _2.Color.blue._60
      })),
      variant: 'tertiary',
      onClick: typeof onHelpLinkClick !== 'string' ? () => onHelpLinkClick() : {
        location: onHelpLinkClick,
        external: true
      },
      className: styles('help-link')
    }));
  };

  const renderTitles = noMargin => {
    const titleSectionComposedClassname = (0, _bind.default)(styles('title-section', {
      'no-subtitle': !noMargin && !subtitle
    }));
    const titleComposedClassname = (0, _bind.default)(styles('question-text', {
      'no-margin': noMargin
    }));
    return _react.default.createElement("div", {
      onMouseOver: () => chatBotQuestion && setShowImage(true),
      onMouseLeave: () => {
        chatBotQuestion && setTimeout(() => {
          setShowImage(false);
        }, 2000);
      }
    }, _react.default.createElement(_2.Flex, {
      className: titleSectionComposedClassname,
      direction: 'column',
      padding: subtitle ? [0, 0, 8, 0] : 0
    }, text && _react.default.createElement(_2.Text, {
      size: questionTextSize,
      variant: 'medium',
      className: titleComposedClassname,
      tag: `span`
    }, text, "\u00A0", chatBotQuestion ? renderChatBotMouseOver() : tooltip ? renderToolTip() : _react.default.createElement(_react.default.Fragment, null)), subtitle && (typeof subtitle === 'string' ? _react.default.createElement(_2.Text, {
      size: questionSubtitleSize,
      color: _2.Color.neutral._80,
      className: styles('question-subtitle', {
        'no-margin': noMargin
      })
    }, subtitle, " ", renderHelp()) : _react.default.createElement("div", {
      className: styles('question-subtitle')
    }, subtitle, renderHelp())), children));
  };

  const renderMultipleSelect = () => {
    const noneOptionsText = ['none of the above'];
    const noneOfMultipleSelectOption = answerOptions && answerOptions.find(o => o.text && noneOptionsText.includes(o.text.trim().toLowerCase()));
    const noneOfMultipleOptionSelected = noneOfMultipleSelectOption && selectedElems.includes(noneOfMultipleSelectOption.id);

    const getMultipleSelectOptions = () => {
      if (answerOptions) {
        return answerOptions.map(o => ({
          text: o.text,
          value: o.id,
          checked: selectedElems.includes(o.id),
          disabled: noneOfMultipleSelectOption && noneOfMultipleOptionSelected && o.id !== noneOfMultipleSelectOption.id
        }));
      }

      return [];
    };

    const dropdownRef = (0, _react.useRef)();
    (0, _useUtils.useDocumentEvent)('mousedown', event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdownMultiSelect(false);
      } else {
        setShowDropdownMultiSelect(true);
      }
    });

    const renderCheckboxGroup = () => {
      return _react.default.createElement("div", {
        className: styles('checkbox-group')
      }, _react.default.createElement(_2.Checkbox, {
        dataTestId: dataTestId && `${dataTestId}-checkbox`,
        options: getMultipleSelectOptions(),
        onChange: e => {
          let nextSelected;

          if (noneOfMultipleSelectOption && e.target.value === noneOfMultipleSelectOption.id) {
            nextSelected = e.target.checked ? [e.target.value] : [];
          } else {
            nextSelected = e.target.checked ? [...selectedElems, e.target.value] : selectedElems.filter(id => id !== e.target.value);
          }

          setSelectedElems(nextSelected);

          if (onChange) {
            onChange(nextSelected, nextSelected);
          }

          if (onAnswerSelected) {
            onAnswerSelected(nextSelected);
          }
        }
      }));
    };

    const displaySelectedElems = selectedElems => {
      const elemsSelected = [];
      selectedElems.forEach(el => {
        const selectedText = answerOptions === null || answerOptions === void 0 ? void 0 : answerOptions.find(text => el === text.id);

        if (selectedText) {
          elemsSelected.push(selectedText.text);
        }
      });
      return elemsSelected.join(', ');
    };

    if (multiSelectDropdown) {
      return _react.default.createElement("div", {
        className: styles('checkbox-dropdown'),
        ref: dropdownRef
      }, _react.default.createElement("div", {
        className: styles('multi-select-field')
      }, selectedElems.length > 0 ? displaySelectedElems(selectedElems) : 'Select'), showDropdownMultiSelect && _react.default.createElement("div", {
        className: styles('dropdown-select')
      }, renderCheckboxGroup()));
    } else {
      return renderCheckboxGroup();
    }
  };

  const renderQuestion = () => {
    var _a, _b;

    if (answerType === `file_upload`) {
      return _react.default.createElement(_fileupload.default, {
        onFileAdded: onFileAdded,
        acceptedFiletypes: acceptedFiletypes,
        maxFileSize: maxFileSize,
        onFileCancelled: onFileCancelled,
        onFileRemoved: onFileRemoved,
        onFileProgressCompleted: onFileProgressCompleted,
        error: error,
        errorText: errorText,
        dataTestId: dataTestId,
        title: renderTitles(true),
        alignItems: 'flex-start',
        flexDirection: fileUploadFlexDirection
      });
    }

    const getFormattedValue = () => {
      if (answerType === 'currency' && _lodash.default.isNumber(inputValue)) {
        return (0, _helpers.CentsToDisplayStringNoSymbol)(inputValue);
      }

      return inputValue;
    };

    return _react.default.createElement(_react.default.Fragment, null, renderTitles(), (answerType === 'text' || answerType === 'text_area' || answerType === 'email' || answerType === 'number' || answerType === 'currency' || answerType === 'percentage' || answerType === 'date' || answerType === 'year' || answerType === 'ssn' || answerType === 'phone_number') && _react.default.createElement(_2.TextField, {
      dataTestId: dataTestId ? `${dataTestId}-textfield` : undefined,
      className: styles('text-field'),
      numericFormat: answerType === 'number',
      currencyFormat: answerType === 'currency',
      percentFormat: answerType === 'percentage',
      dateFormat: answerType === 'date',
      yearFormat: answerType === 'year',
      socialSecurityFormat: answerType === 'ssn',
      multiline: answerType === 'text_area',
      phoneNumber: answerType === 'phone_number',
      rows: answerType === 'text_area' ? 3 : '',
      value: getFormattedValue(),
      placeholder: placeholder,
      error: error,
      label: label,
      disabled: disabled,
      onChange: e => {
        setInputValue(e.target.value);

        if (onChange) {
          if (answerType === 'year') {
            const rawYear = e.target.value;
            const value = !rawYear || rawYear.length < 4 ? NaN : parseAnswerValue(rawYear, answerType);
            onChange(value, rawYear);
          } else {
            const value = parseAnswerValue(e.target.value, answerType);
            onChange(value, e.target.value);
          }
        }
      },
      onBlur: e => {
        setInputValue(e.target.value);

        if (onBlur) {
          onBlur(parseAnswerValue(e.target.value, answerType), e.target.value);
        }
      }
    }), answerOptions && (answerType === 'button_select' || answerType === 'button_multiple_select' || answerType === 'yes_or_no' || answerType === 'yes_no_or_unknown') && _react.default.createElement("div", {
      className: styles('button-group', {
        'no-min-width': buttonGroupNoMinWidth,
        'button-group-wrap': buttonGroupWrap
      })
    }, answerOptions.map(renderButton)), answerOptions && answerType === 'multiple_choice' && _react.default.createElement("div", {
      className: styles('radio-group')
    }, _react.default.createElement(_2.RadioGroup, {
      dataTestId: dataTestId && `${dataTestId}-radio`,
      name: `radio-group-${dataTestId}`,
      value: selectedId,
      gap: 24,
      options: answerOptions.map(o => {
        return {
          name: o.text,
          value: o.id
        };
      }),
      onChange: e => {
        setSelectedId(e.target.value);

        if (onChange) {
          onChange(e.target.value, e.target.value);
        }

        if (onAnswerSelected) {
          onAnswerSelected(e.target.value);
        }
      },
      onClick: () => onClick && onClick()
    })), answerOptions && answerType === 'multiple_select' && renderMultipleSelect(), answerOptions && (answerType === 'dropdown_select' || answerType === 'dropdown_select_only') && _react.default.createElement("div", {
      className: styles('dropdown-select')
    }, _react.default.createElement(_2.Dropdown, {
      dataTestId: dataTestId && `${dataTestId}-dropdown`,
      value: (_b = (_a = answerOptions.find(o => o.id === String(selectedId))) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : '',
      options: answerOptions.map(o => {
        return {
          name: o.text,
          value: o.id
        };
      }),
      onInputChange: option => {
        const value = typeof option === 'string' ? option : option.value;
        setSelectedId(value);

        if (onChange) {
          onChange(value, value);
        }

        if (onAnswerSelected) {
          onAnswerSelected(value);
        }
      },
      placeholder: placeholder,
      selectOnly: answerType === 'dropdown_select_only'
    })), helperText && (!error || !errorText) && _react.default.createElement(_2.Text, {
      dataTestId: dataTestId && `${dataTestId}-helper-text`,
      className: styles('helper-text'),
      size: 15,
      text: helperText
    }), error && errorText && _react.default.createElement("div", {
      className: styles('error-message'),
      "data-testid": dataTestId && `${dataTestId}-error`
    }, _react.default.createElement(_2.Icon, {
      name: _2.IconEnum.exclamation_circle,
      color: _2.Color.semantic.$error50
    }), _react.default.createElement("div", null, _react.default.createElement(_2.Text, {
      size: 15,
      status: 'failed',
      text: 'Error:',
      variant: 'medium',
      tag: 'span',
      className: styles('error-label')
    }), _react.default.createElement(_2.Text, {
      size: 15,
      status: 'failed',
      text: errorText,
      tag: 'span'
    }))));
  };

  const contentPadding = answerType === 'file_upload' ? 0 : 24;

  if (withCard) {
    return _react.default.createElement(_2.Card, {
      className: className,
      dataTestId: dataTestId,
      noMargin: !withCardMargin,
      ...props
    }, _react.default.createElement(_2.Content, {
      paddingTopBottom: contentPadding,
      paddingLeftRight: contentPadding
    }, renderQuestion(), bottomContent));
  }

  return _react.default.createElement("div", {
    className: (0, _bind.default)(styles('no-card'), className),
    "data-testid": dataTestId,
    ...props
  }, renderQuestion(), bottomContent);
});
var _default = SurveyQuestion;
exports.default = _default;